import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
    const { exchangeCode } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            // Code is in URL fragment (#code=...) — never sent to server in subsequent navs
            const hash = window.location.hash || "";
            const m = hash.match(/code=([^&]+)/);
            if (!m) {
                setError("Codice mancante");
                setTimeout(() => navigate("/login?magic_error=missing_code", { replace: true }), 1500);
                return;
            }
            const code = decodeURIComponent(m[1]);
            // Clear the fragment immediately
            window.history.replaceState(null, "", window.location.pathname);
            try {
                const data = await exchangeCode(code);
                navigate(data.role === "admin" ? "/admin" : "/app", { replace: true });
            } catch (e) {
                const detail = e?.response?.data?.detail || "session_expired";
                setError(detail);
                setTimeout(() => navigate(`/login?magic_error=${encodeURIComponent(detail)}`, { replace: true }), 1500);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-white p-6" data-testid="auth-callback-page">
            <div className="h-8 w-8 bg-acid mb-8 grain" />
            <span className="label-tag">— Autenticazione in corso</span>
            <h1 className="font-display text-4xl lg:text-5xl mt-4 tracking-tighter text-center">
                Ti stiamo facendo<br /><span className="font-serif-italic text-acid">accedere</span>…
            </h1>
            {!error ? (
                <Loader2 className="h-8 w-8 text-acid animate-spin mt-10" />
            ) : (
                <p className="text-magenta mt-6 max-w-md text-center font-grotesk" data-testid="auth-callback-error">{error}</p>
            )}
        </div>
    );
}
